import React from "react";
import { Alert, Button, Card, Form, Stack } from "react-bootstrap";
import "../../../css/account-migration.css";
import { useAppSelector } from "../../redux/hooks";
import { sanitizeReturnTo } from "../utilities/AuthenticationUtils";

const LOGO_URL =
    "https://assets-viridischem-com.s3.us-east-1.amazonaws.com/static/img/viridischem-logo-polished.svg";

export const RegistrationComplete: React.FC = () => {
    const csrfToken = useAppSelector((state) => state.user.csrf_token);
    const accountManagementAvailable = useAppSelector(
        (state) =>
            state.authentication.session?.externalAccountManagementAvailable ===
            true
    );

    return (
        <main className="account-migration-page">
            <Card className="account-migration-card">
                <Card.Body>
                    <Stack gap={4}>
                        <img
                            className="account-migration-logo"
                            src={LOGO_URL}
                            alt="ViridisChem"
                            width="280"
                            height="56"
                        />
                        <div className="account-migration-intro">
                            <h1>Your ViridisChem account is ready</h1>
                            <p>
                                Continue to ViridisChem now. Multi-factor
                                authentication is optional and can be set up
                                here or later from Manage ViridisChem Sign-In.
                            </p>
                        </div>
                        <Button
                            as="a"
                            href={sanitizeReturnTo(
                                new URLSearchParams(window.location.search).get(
                                    "returnTo"
                                )
                            )}
                            size="lg"
                            className="w-100"
                        >
                            Continue to ViridisChem
                        </Button>
                        {accountManagementAvailable && csrfToken ? (
                            <Form method="post" action="/api/1.0/auth/account">
                                <input
                                    type="hidden"
                                    name="csrf-token"
                                    value={csrfToken}
                                />
                                <Button
                                    type="submit"
                                    size="lg"
                                    variant="outline-primary"
                                    className="w-100"
                                >
                                    Set up MFA
                                </Button>
                            </Form>
                        ) : (
                            <Alert variant="secondary">
                                MFA setup is available later from Manage
                                ViridisChem Sign-In in the user menu.
                            </Alert>
                        )}
                    </Stack>
                </Card.Body>
            </Card>
        </main>
    );
};

export default RegistrationComplete;
